// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-navigation {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.9);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.nav-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 1rem 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.nav-logo {
  font-size: 1.25rem;
  font-weight: 700;
  color: #fff;
  text-decoration: none;
  transition: opacity 0.3s ease;
}

.nav-logo:hover {
  opacity: 0.8;
}

.nav-links {
  display: flex;
  gap: 2rem;
  align-items: center;
}

.nav-link {
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  font-size: 0.95rem;
  font-weight: 500;
  transition: color 0.3s ease;
  position: relative;
}

.nav-link:hover {
  color: #fff;
}

.nav-link.active {
  color: #fff;
}

.nav-link.active::after {
  content: '';
  position: absolute;
  bottom: -4px;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, #667eea, #764ba2);
  border-radius: 2px;
}

.nav-cta {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #fff !important;
  padding: 0.5rem 1.25rem;
  border-radius: 20px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.nav-cta:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(102, 126, 234, 0.4);
}

/* Add padding to content to account for fixed nav */
body {
  padding-top: 70px;
}

@media (max-width: 768px) {
  .nav-container {
    padding: 1rem 1.5rem;
  }
  
  .nav-links {
    gap: 1rem;
  }
  
  .nav-link {
    font-size: 0.875rem;
  }
  
  .nav-cta {
    padding: 0.4rem 1rem;
    font-size: 0.875rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Navigation.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,aAAa;EACb,8BAA8B;EAC9B,2BAA2B;EAC3B,iDAAiD;AACnD;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,WAAW;EACX,oDAAoD;EACpD,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;EAC7D,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA,oDAAoD;AACpD;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;EACrB;AACF","sourcesContent":[".main-navigation {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 1000;\n  background: rgba(0, 0, 0, 0.9);\n  backdrop-filter: blur(10px);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.nav-container {\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 1rem 2rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.nav-logo {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: #fff;\n  text-decoration: none;\n  transition: opacity 0.3s ease;\n}\n\n.nav-logo:hover {\n  opacity: 0.8;\n}\n\n.nav-links {\n  display: flex;\n  gap: 2rem;\n  align-items: center;\n}\n\n.nav-link {\n  color: rgba(255, 255, 255, 0.7);\n  text-decoration: none;\n  font-size: 0.95rem;\n  font-weight: 500;\n  transition: color 0.3s ease;\n  position: relative;\n}\n\n.nav-link:hover {\n  color: #fff;\n}\n\n.nav-link.active {\n  color: #fff;\n}\n\n.nav-link.active::after {\n  content: '';\n  position: absolute;\n  bottom: -4px;\n  left: 0;\n  right: 0;\n  height: 2px;\n  background: linear-gradient(90deg, #667eea, #764ba2);\n  border-radius: 2px;\n}\n\n.nav-cta {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: #fff !important;\n  padding: 0.5rem 1.25rem;\n  border-radius: 20px;\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.nav-cta:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 5px 15px rgba(102, 126, 234, 0.4);\n}\n\n/* Add padding to content to account for fixed nav */\nbody {\n  padding-top: 70px;\n}\n\n@media (max-width: 768px) {\n  .nav-container {\n    padding: 1rem 1.5rem;\n  }\n  \n  .nav-links {\n    gap: 1rem;\n  }\n  \n  .nav-link {\n    font-size: 0.875rem;\n  }\n  \n  .nav-cta {\n    padding: 0.4rem 1rem;\n    font-size: 0.875rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
